import PropTypes from 'prop-types';

const BreakpointShape = PropTypes.shape({
  columns: PropTypes.number,
  columnGap: PropTypes.number,
  minWidth: PropTypes.number,
  name: PropTypes.oneOf(['mobile', 'tablet', 'tablet+', 'desktop', 'desktop+']),
  rowGap: PropTypes.number,
});

const BreakpointsShape = PropTypes.arrayOf(BreakpointShape);

export { BreakpointShape, BreakpointsShape };
